<div class="relative h-[calc(100vh-90px)] w-full overflow-hidden rounded-2xl">
  <!-- Live map fills the whole area -->
  <div class="absolute inset-0">
    <app-live-map-widget
      [vehicles]="vehicles"
      [selectedId]="selectedId"
      (vehicleSelected)="onSelect($event)"
    ></app-live-map-widget>
  </div>

  <!-- Floating top bar with fleet counters -->
  <div class="pointer-events-none absolute top-4 left-1/2 -translate-x-1/2 z-20">
    <div class="pointer-events-auto flex items-center gap-4 rounded-2xl bg-white/95 dark:bg-[#0e1726]/95 backdrop-blur border border-gray-100 dark:border-white/10 shadow-xl px-5 py-2.5">
      <div class="flex items-center gap-1.5 text-xs font-semibold text-[#0e1726] dark:text-white">
        <svg class="h-4 w-4 text-primary" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
          <path d="M3 12h4l2-6 4 12 2-6h6" />
        </svg>
        Centro de mando
      </div>
      <div class="h-5 w-px bg-gray-200 dark:bg-white/10"></div>

      <div class="flex items-center gap-1.5">
        <span class="h-2.5 w-2.5 rounded-full" style="background-color: #10b981"></span>
        <span class="text-sm font-bold text-[#0e1726] dark:text-white">{{ movingCount }}</span>
        <span class="text-[11px] text-gray-400 dark:text-white/50">movim.</span>
      </div>
      <div class="flex items-center gap-1.5">
        <span class="h-2.5 w-2.5 rounded-full" style="background-color: #ef4444"></span>
        <span class="text-sm font-bold text-[#0e1726] dark:text-white">{{ stoppedCount }}</span>
        <span class="text-[11px] text-gray-400 dark:text-white/50">detenidos</span>
      </div>
      <div class="flex items-center gap-1.5">
        <span class="h-2.5 w-2.5 rounded-full" style="background-color: #f59e0b"></span>
        <span class="text-sm font-bold text-[#0e1726] dark:text-white">{{ idleCount }}</span>
        <span class="text-[11px] text-gray-400 dark:text-white/50">ralentí</span>
      </div>
    </div>
  </div>

  <!-- Collapse/expand toggle -->
  <button
    type="button"
    (click)="togglePanel()"
    class="absolute top-4 z-30 grid h-9 w-9 place-content-center rounded-full bg-white/95 dark:bg-[#0e1726]/95 backdrop-blur border border-gray-100 dark:border-white/10 shadow-lg text-gray-600 dark:text-white transition-all"
    [ngClass]="panelCollapsed ? 'left-4' : 'left-[340px]'"
    [attr.aria-label]="panelCollapsed ? 'Expandir panel' : 'Colapsar panel'"
  >
    <svg class="h-4 w-4 transition-transform" [class.rotate-180]="panelCollapsed" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="m15 18-6-6 6-6" />
    </svg>
  </button>

  <!-- Floating collapsible side panel (left) -->
  <div
    class="absolute top-4 bottom-4 left-4 z-20 w-[312px] transition-all duration-300"
    [ngClass]="panelCollapsed ? '-translate-x-[130%] opacity-0 pointer-events-none' : 'translate-x-0 opacity-100'"
  >
    <app-fleet-side-panel
      [vehicles]="vehicles"
      [selectedId]="selectedId"
      (select)="onSelect($event)"
    ></app-fleet-side-panel>
  </div>
</div>
